export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  LOGOUT: "USERS_LOGOUT",

  SWITCH_SUB: "USERS_SWITCH",
  SWITCH_MAIN: "USERS_SWITCH_MAIN",
  SET_USER_RECENT_VERSION: "USERS_SET_USER_RECENT_VERSION"
};
